import { render, staticRenderFns } from "./CopyStakeWhitelistConfirmModal.vue?vue&type=template&id=a45525a2&scoped=true&lang=pug"
import script from "./CopyStakeWhitelistConfirmModal.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWhitelistConfirmModal.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWhitelistConfirmModal.vue?vue&type=style&index=0&id=a45525a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45525a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
